import styled from 'styled-components'
import { CardHeader } from 'reactstrap'

export const Header = styled(CardHeader)`
  display: flex !important;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  height: auto !important;
  min-height: 3.5rem;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  text-transform: none !important;

  > div:last-child {
    display: flex;
    flex-wrap: nowrap;
  }

  @media only screen and (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const Periodo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  span {
    font-size: 0.72rem;
    font-weight: 400;
    color: #6c757d;
    text-transform: uppercase;
  }
  strong {
    font-size: 0.95rem;
    font-weight: 600;
    color: #273576;
  }
`
